const cardData = [
  {
    id: 1,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 2,
    image:
      "https://images.pexels.com/photos/2106673/pexels-photo-2106673.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "1,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 3,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "50,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 4,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 5,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Stories by Parag",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 6,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 7,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 8,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Stories by Parag",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 9,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 10,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 11,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Stories by Parag",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 12,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 13,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 14,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Stories by Parag",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 15,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,50,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 16,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 17,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Stories by Parag",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 18,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 19,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 20,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 21,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 22,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 23,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Stories by Parag",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 24,
    image:
      "https://images.pexels.com/photos/10332889/pexels-photo-10332889.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 25,
    image:
      "https://images.pexels.com/photos/7184081/pexels-photo-7184081.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "Happy Framers",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "2,50,000",
    voteOne: "10",
    voteTwo: "30",
  },
  {
    id: 26,
    image:
      "https://images.pexels.com/photos/11762791/pexels-photo-11762791.jpeg?auto=compress&cs=tinysrgb&w=1600",
    name: "CamLens Photography",
    location: "Karachi",
    shortDesc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt consequuntur quo laudantium rem repellendus voluptatibus. Laboriosam cumque veniam nulla aliquam",
    tooltip: "Lorem ipsum dolor sit amet consectetur adipisicing elit",
    rating: "4.9",
    reviews: "61",
    category: "Photo + Video",
    budget: "1,00,000",
    voteOne: "10",
    voteTwo: "30",
  },
];

export default cardData;
